import * as React from "react";
import {
    List,
    Show,
    Edit,
    Create,

    Datagrid,
    SimpleShowLayout,
    SimpleForm,
    TextField,
    EmailField,
    DateField,
    TextInput,
    DateInput,
    BooleanField,
    ArrayField,
    SelectField,
    SelectInput,

    TabbedShowLayout,
    Tab,
    Toolbar,
    SaveButton,
    useRecordContext,
    WrapperField,
    NumberField,
    FunctionField,
    FormDataConsumer,
    SavedQueriesList,
    FilterLiveSearch,
    FilterList,
    FilterListItem,
    LoadingIndicator,
    useRedirect,
    useNotify,
    useDataProvider,
    Button,
    TopToolbar,
    useUpdate,
    FileField,
    ReferenceArrayInput,
    AutocompleteArrayInput,
    Filter,
    ListBase,
    Title,
    ListToolbar,
    Pagination,
    WithListContext,
    Confirm,
    useTranslate,
    downloadCSV,
    ReferenceInput,
    AutocompleteInput,
    useGetOne,
} from 'react-admin';
import { useNavigate } from "react-router-dom";
import { useController, useForm } from "react-hook-form";
import Grid from '@mui/material/Grid';
import { designations, formEntryStatuses, frontendFormUrl, getDesignations, getStatuses, humanFileSize, round, stateAbbrToName, toSelectChoices } from "../helpers/strings";
// import { QuizzBuilder, Quiz } from "react-quizzes"
// import "react-quizzes/lib/assets/antd.css";
// import "./Forms.css";
// import "./FormEdit.scoped.css";
// import { sectionChoices } from "../helpers";
// import {ReactFormeoEditor, ReactFormeoRenderer} from "../Components/Formeo";
// import { FormeoEditor, FormeoRenderer } from 'formeo'
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import AssignmentIcon from '@mui/icons-material/Assignment';
import MailIcon from '@mui/icons-material/MailOutline';
import CategoryIcon from '@mui/icons-material/LocalOffer';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import RateReviewIcon from '@mui/icons-material/RateReview';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import AlertError from '@mui/icons-material/ErrorOutline';
import { authenticatedApi } from "../dataProvider";
import { TabCount } from "../Components/TabCount";
import { CommunityOptionRenderer, GenericOptionRenderer } from "../Components/OptionRenderer";
import { EditInDialogButton } from "@react-admin/ra-form-layout";
import { format, parseISO } from "date-fns";
import jsonExport from 'jsonexport/dist';

// Todo: ensure standards are met before showing summary


const calculateAverageForStandard = (entry, standard) => {
if(!entry) {
    return 0;
}

let total = 0;
let numberOfIndicators = 0;

// for(const standard of props.form.standards) {
    for(const keyIndicator of standard.key_indicators) {
        for(const indicator of keyIndicator.indicators) {
            let answer = entry.entry.find(obj => obj.indicator_id === indicator.id);
            if(!answer) {
                return 0;
            }

            // todo: handle for cp and msa too
            total += answer.lp_answer;
            numberOfIndicators++;
        }
    }
// }

return round(total/numberOfIndicators);
}


export const ConditionalScoringField = () => {
    const record = useRecordContext();

    if(!record || record.score === null) return <WrapperField label="Score" />;

    return (
        <WrapperField label="Score">
            <BooleanField source="passed" looseValue={true} valueLabelTrue={'Passed'} valueLabelFalse={'FAILED'} />
            <NumberField source="score" label="Score" options={{ maximumFractionDigits: 0 }} />%
        </WrapperField>
    );
}

export const FormEntryCommunityField = (props) => {
    const record = useRecordContext();
    const {label, source, ...restProps} = props;

    if(!record.community) {
        return (
            <FunctionField label={label} source={source} render={record => record.community_id ? <em>Deleted Community (ID #{record.community_id})</em> : <em>Unknown Community</em>} />
        );
    }

    return (
        <WrapperField label={label} sortable={!props.hasOwnProperty('sortable') || props.sortable === true} sortBy="community.name">
            <TextField source="community.city" />, <FunctionField label="State" source="community.state" render={record => stateAbbrToName(record.community.state)} />
            <br/><TextField source="community.name" />
            {/* <br/><FunctionField label="Designation" source="designation" render={record => getDesignations(record.community.designation ?? null)} /> */}
        </WrapperField>
    );
};

const FormListSidebar = (props) => {
    const [isLoading, setIsLoading] = React.useState(true);
    const [forms, setForms] = React.useState([]);

    const navigate = useNavigate();

    React.useEffect(() => {
        authenticatedApi.get('/forms').then(response => {
            setForms(response.data.data);
            setIsLoading(false);
        });
    }, []);

    if(isLoading) {
        return (
            <Card sx={{ order: -1, mr: 2, mt: 6, maxWidth: 300 }}>
                <CardContent>
                    <LoadingIndicator/>
                </CardContent>
            </Card>
        );
    }

    return (
        <Card sx={{ order: -1, mr: 2, mt: 6, maxWidth: 300 }}>
            <CardContent>
                <Button label="View Averages" onClick={() => navigate('/form-entries/average')}><EqualizerIcon/></Button>
                <div className="" style={{borderTop: '1px solid #e0e0e0', marginTop: 8, marginBottom: 8}}></div>

                {/* <SavedQueriesList /> */}
                <FilterLiveSearch />
                <FilterList label="Form" icon={<AssignmentIcon />}>
                    {forms.map(form => (
                        <FilterListItem key={form.id} label={form.name} value={{ form_id: form.id }} />
                    ))}
                </FilterList>
                <FilterList label="Status" icon={<CategoryIcon />}>
                    {Object.entries(formEntryStatuses).map(item => (
                        <FilterListItem key={item[0]} label={item[1]} value={{ status: item[0] }} />
                    ))}
                </FilterList>

                {/* todo: filter by community's coordinating program */}
            </CardContent>
        </Card>
    );
};

const formEntryAverageFilters = [
    <ReferenceInput source="form_id" label="Forms" reference="forms" perPage={-1}>
       <AutocompleteInput label="Forms" optionText={<GenericOptionRenderer/>} inputText={choice => choice.name} />
    </ReferenceInput>

    ,

    <ReferenceArrayInput source="community.coordinating_program_id" label="Coordinating Programs" reference="coordinating-programs" perPage={-1}>
        <AutocompleteArrayInput label="Coordinating Programs" optionText={<GenericOptionRenderer/>} inputText={choice => choice.name} />
    </ReferenceArrayInput>

    ,

    <ReferenceArrayInput source="community_id" label="Communities" reference="communities" perPage={-1}>
       <AutocompleteArrayInput label="Communities" optionText={<CommunityOptionRenderer/>} inputText={choice => choice.name} />
    </ReferenceArrayInput>
];

export const FormEntryAverage = (props) => {
    return (
        <List disableSyncWithLocation={true} filters={formEntryAverageFilters} filterDefaultValues={{form_id: 0}} resource="form-entries" perPage={9999} title={"Communities to Average"} {...props} exporter={false} queryOptions={{meta: {include: 'none'}}}>
            <WithListContext render={({ filterValues, data, isLoading }) => {
                const { form_id, community, community_id } = filterValues;

                if(isLoading) {
                    // todo: return loading icon
                    return null;
                }

                if(!form_id || form_id == 0) {
                    return <Card sx={{padding: 2}}><em>You must choose a form.</em></Card>
                }

                const hasCommunityCPFilters = typeof community_id !== 'undefined' && typeof community !== 'undefined';

                return (<>
                    <Card sx={{padding: 2}}>
                        <Typography variant="h6">{data.length} {data.length === 1 ? 'Community' : 'Communities'}</Typography>
                        {/* {Object.entries(filterValues).length === 0 && (<em>To limit results, use the "Add Filters" button on the upper right side of the screen.</em>)} */}
                        {hasCommunityCPFilters && (<em><b>Note:</b> Filtering both coordinating programs and communities at the same time may lead to unexpected results. Please use one or the other.</em>)}
                        {/*
                        <Typography variant="body2">
                            Total views: {data.reduce((sum, post) => sum + post.id, 0)}
                        </Typography>
                        */}
                        {data.length === 0 && (<em>There are no results to display.</em>)}
                    </Card>
                    {data.length > 0 && (<FormEntryField data={data}/>)}
                </>)
            }} />
        </List>
    );
}

const formEntryExporter = (entries, fetchRelatedRecords) => {
    fetchRelatedRecords(entries, 'coordinating_program_id', 'coordinating-programs').then(coordinatingPrograms => {
        const data = entries.map(entry => ({
            'Member Number': entry?.community?.member_number ?? 'N/A',
            Name: entry?.community?.name ?? 'N/A',
            City: entry?.community?.city ?? 'N/A',
            State: entry?.community?.state ?? 'N/A',
            Designation: entry?.community?.designation ? (getDesignations(entry.community.designation ?? null) ?? entry.community.designation) : 'N/A',
            'Coordinating Program': entry?.community?.coordinating_program_id ? coordinatingPrograms?.[entry.community.coordinating_program_id]?.name : '',
            Form: entry.form.name,
            Status: getStatuses(entry.status),
            // todo: answers?
        }));

        return jsonExport(data, {
            headers: [
                'Member Number',
                'Name',
                'City',
                'State',
                'Designation',
                'Coordinating Program',
                'Form',
                'Status',
            ]
        }, (err, csv) => {
            downloadCSV(csv, 'entries');
        });
    });

    /*
    const dataForExport = entries.map(entry => {
        console.log(entry);
        return {
            'Member Number': entry.community.member_number,
            Name: entry.community.name,
            City: entry.community.city,
            State: entry.community.state,
            Designation: getDesignations(entry.community.designation ?? null) ?? entry.community.designation,
            // todo: coordinating program?
            // 'Coordinating Program': entry.community?.coordinating_program?.name ?? '',
            Form: entry.form.name,
            Status: getStatuses(entry.status),
            // todo: answers?
        }
    });

    jsonExport(dataForExport, {
        headers: ['Member Number', 'Name', 'City', 'State', 'Designation', 'Form', 'Status']
    }, (err, csv) => {
        downloadCSV(csv, 'entries');
    });
    */
};

const FormEntryList = props => (
    <List aside={<FormListSidebar/>} title={"All Form Entries"} exporter={formEntryExporter} {...props}>
        <Datagrid rowClick="show" bulkActionButtons={false}>
            <FormEntryCommunityField label="Community" source="community" />
            <FunctionField label="Designation" source="designation" render={record => getDesignations(record.community?.designation ?? null)} />

            <TextField sortable={!props.hasOwnProperty('sortable') || props.sortable === true} source="form.name" label="Form" />

            <FunctionField label="Status" source="status" render={record => getStatuses(record.status)} />


            <FormEntryUpdateStatusButton />
            <FormEntryFrontendButton />

            {/* <DateField sortable={!props.hasOwnProperty('sortable') || props.sortable === true} source="created_at" label="Submitted Date" /> */}

            {/* <ConditionalScoringField label="Score" /> */}
            {/*
            <WrapperField label="Score">
                <BooleanField source="passed" looseValue={true} valueLabelTrue={'Passed'} valueLabelFalse={'FAILED'} />
                <NumberField source="score" label="Score" />
            </WrapperField>
            */}

            {/*
            <TextField source="name" />
            <SelectField source="section" choices={sectionChoices} />
            <TextField source="category" />
            */}

            {/* type of form (form vs quiz) */}
        </Datagrid>
    </List>
);

export const FormEntryField = (props) => {
    const providedRecord = useRecordContext(props);

    /*
    let formId = null;
    try {
        formId = props.data[0].form_id;
    } catch(e) {
        //
    }

    const { data: formData, isPending: formDataPending } = useGetOne('forms', {id: formId, meta: {include: 'default'}}, {enabled: formId !== null});

    if(!formData) {
        return null;
    }

    // todo change toLoop[0].form to formData
    */

    if(!providedRecord && !props.data && !props.data.length) {
        return null;
    }

    const toLoop = props.data ?? [providedRecord];

    const answerFor = (object, responseKey, standardId = 'additional-information') => {
        for(const record of toLoop) {
        const entry = JSON.parse(record.entry);
        let answer = entry.find(row => row.standard_id && row.standard_id === standardId);
        // let responseKey = `lp_answer_${objectIndex}`;
        if(!answer || !answer[responseKey]) {
            return 'N/A';
        }

        let questionResponse = answer[responseKey];

        if(object.type == 'boolean') {
            return questionResponse == 'yes' ? 'Yes' : 'No';
        }

        if(object.type == 'date') {
            try {
                // questionResponse = parseISO(questionResponse);
                questionResponse = format(parseISO(questionResponse), 'MM/dd/yy');
            } catch(e) {}
        }

        if(Array.isArray(questionResponse)) {
            questionResponse = questionResponse.join('<br/>');
        }

        return <div dangerouslySetInnerHTML={{__html: questionResponse}}></div>;
        }

        // console.log(object);
        // return null;
    }

    const scoreFor = (type, object) => {
        let returnAnswer = {
            lp: 0,
            cp: 0,
            msa: 0,
        };
        let lpTotal = 0;
        let cpTotal = 0;
        let msaTotal = 0;

        for(const record of toLoop) {
            const entry = JSON.parse(record.entry);
            let indicatorIds = [];

            if(type === 'indicator') {
                indicatorIds.push(object.id);
                // let answer = entry.find(row => row.indicator_id && row.indicator_id === object.id);
                // returnAnswer.lp = answer.lp_answer;
            } else if(type === 'keyIndicator') {
                indicatorIds = object.indicators.map(i => i.id);
            } else if(type === 'standard') {
                object.key_indicators.map(kI => {
                    indicatorIds.push(...kI.indicators.map(i => i.id));
                })
            } else if(type === 'baseline-requirement') {
                let answer = entry.find(row => row.standard_id && row.standard_id === 'baseline-requirements');

                if(toLoop.length === 1) {
                    returnAnswer = {
                        lp: answer ? (answer[`lp_requirement_${object.id}`] == 'yes' ? 'Yes' : 'No') : 'N/A',
                        cp: answer ? (answer[`cp_requirement_${object.id}`] == 'yes' ? 'Yes' : 'No') : 'N/A',
                        msa: answer ? (answer[`msa_requirement_${object.id}`] == 'yes' ? 'Yes' : 'No') : 'N/A',
                    };

                    return returnAnswer;
                } else {
                    if(answer) {
                        if(answer[`lp_requirement_${object.id}`]) {
                            lpTotal++;
                            if(answer[`lp_requirement_${object.id}`] == 'yes') {
                                returnAnswer.lp++;
                            }
                        }

                        if(answer[`cp_requirement_${object.id}`]) {
                            cpTotal++;
                            if(answer[`cp_requirement_${object.id}`] == 'yes') {
                                returnAnswer.cp++;
                            }
                        }

                        if(answer[`msa_requirement_${object.id}`]) {
                            msaTotal++;
                            if(answer[`msa_requirement_${object.id}`] == 'yes') {
                                returnAnswer.msa++;
                            }
                        }
                    }
                }
            }

            for(const indicatorId of indicatorIds) {
                let answer = entry.find(row => row.indicator_id && row.indicator_id === indicatorId);
                if(!answer) {
                    continue;
                }

                if(answer.lp_answer !== null) {
                    lpTotal++;
                    returnAnswer.lp += answer.lp_answer;
                }

                if(answer.cp_answer !== null) {
                    cpTotal++;
                    returnAnswer.cp += answer.cp_answer;
                }

                if(answer.msa_answer !== null) {
                    msaTotal++;
                    returnAnswer.msa += answer.msa_answer;
                }
            }
        }

        returnAnswer.lp = lpTotal ? round(returnAnswer.lp / lpTotal) : 0;
        returnAnswer.cp = cpTotal ? round(returnAnswer.cp / cpTotal) : 0;
        returnAnswer.msa = msaTotal ? round(returnAnswer.msa / msaTotal) : 0;

        if(type === 'baseline-requirement') {
            returnAnswer.lp = `${(returnAnswer.lp *100)}% Yes`;
            returnAnswer.cp = `${(returnAnswer.cp *100)}% Yes`;
            returnAnswer.msa = `${(returnAnswer.msa *100)}% Yes`;
        }

        return returnAnswer;
    };


    /*
    <table className="table-auto bg-white rounded shadow my-6">
            <thead>
                <tr className={`text-sm font-semibold tracking-tight text-gray-600 px-6 py-3`}>
                    <th className="px-6 pt-3 pb-1.5 text-left">Cumulative Average Scores</th>
                    <th className="px-6 pt-3 pb-1.5 text-enter">LP</th>
                </tr>
            </thead>
            <tbody>
            {props.form.standards.map((standard, index) => {
                return (
                    <tr className={`text-sm font-semibold tracking-tight text-gray-600 px-6 py-3 ${index % 2 === 0 ? 'bg-gray-100' : 'bg-white'}`} key={index}>
                        <td className="px-6 py-3">{standard.name}</td>
                        <td className="px-6 py-3 text-center">{calculateAverageForStandard(standard)}</td>
                    </tr>
                );
            })}
            </tbody>
        </table>
    */


    return (<>
        <TableContainer component={Paper}>
            <Table aria-label="simple table" sx={{ 'tr > :first-child': {paddingLeft: '32px'}, 'tr > :last-child': {paddingRight: '32px'} }}>
                <TableHead>
                <TableRow>
                    <TableCell></TableCell>
                    <TableCell align="right">LP</TableCell>
                    <TableCell align="right">CP</TableCell>
                    <TableCell align="right">MSA</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                <TableRow
                    sx={{ '& > *': {fontWeight: 'bold'}, '&:last-child td, &:last-child th': { border: 0 } }}
                >
                    <TableCell component="th" scope="row">
                        Baseline Requirements
                    </TableCell>
                    <TableCell align="right"></TableCell>
                    <TableCell align="right"></TableCell>
                    <TableCell align="right"></TableCell>
                </TableRow>
                {toLoop[0].form.baseline_requirements.map((requirement) => (<React.Fragment key={requirement.name}>
                    <TableRow
                        sx={{ '& p': {display: 'inline-block'}, '& > *': {fontStyle: 'italic'}, 'th:first-child': {paddingLeft: '64px'}, '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                        <TableCell component="th" scope="row" sx={{'& p':{margin: 0}}}>
                            <div dangerouslySetInnerHTML={{__html: `${requirement.name}. ${requirement.description}`}}></div>
                            {toLoop.length === 1 && Array.isArray(requirement.additional_schema) && requirement.additional_schema.length > 0 && (<>
                                {requirement.additional_schema.map((question, questionIndex) => {
                                    return (
                                        <div className={`text-sm font-semibold tracking-tight text-gray-600 mt-3`} style={{marginTop: '8px'}} key={questionIndex}>
                                            <div style={{/*fontWeight: 'bold',*/ fontStyle: 'italic'}} dangerouslySetInnerHTML={{__html: question.question}}></div>
                                            {answerFor(question, `lp_requirement_${requirement.id}_answer_${question.id}`, 'baseline-requirements')}
                                        </div>
                                    );
                                })}
                            </>)}
                        </TableCell>
                        <TableCell align="right">{scoreFor('baseline-requirement', requirement).lp}</TableCell>
                        <TableCell align="right">{/*{scoreFor('baseline-requirement', requirement).cp}*/}</TableCell>
                        <TableCell align="right">{/*{scoreFor('baseline-requirement', requirement).msa}*/}</TableCell>
                    </TableRow>
                </React.Fragment>))}
                {toLoop[0].form.standards.map((standard) => (<React.Fragment key={standard.name}>
                    <TableRow
                    sx={{ '& > *': {fontWeight: 'bold'}, '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                        <TableCell component="th" scope="row">
                            {standard.name}
                        </TableCell>
                        <TableCell align="right">{scoreFor('standard', standard).lp}</TableCell>
                        <TableCell align="right">{scoreFor('standard', standard).cp}</TableCell>
                        <TableCell align="right">{scoreFor('standard', standard).msa}</TableCell>
                    </TableRow>
                    {standard.key_indicators.map((keyIndicator) => (<React.Fragment key={keyIndicator.name}>
                        <TableRow
                            sx={{ '& > *': {fontStyle: 'italic'}, 'th:first-child': {paddingLeft: '64px'}, '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell component="th" scope="row">
                                {keyIndicator.name}
                            </TableCell>
                            <TableCell align="right">{scoreFor('keyIndicator', keyIndicator).lp}</TableCell>
                            <TableCell align="right">{scoreFor('keyIndicator', keyIndicator).cp}</TableCell>
                            <TableCell align="right">{scoreFor('keyIndicator', keyIndicator).msa}</TableCell>
                        </TableRow>
                        {keyIndicator.indicators.map((indicator) => (<React.Fragment key={indicator.name}>
                            <TableRow
                                sx={{ 'th:first-child': {paddingLeft: '96px'}, '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell component="th" scope="row">
                                    {indicator.name}
                                </TableCell>
                                <TableCell align="right">{scoreFor('indicator', indicator).lp}</TableCell>
                                <TableCell align="right">{scoreFor('indicator', indicator).cp}</TableCell>
                                <TableCell align="right">{scoreFor('indicator', indicator).msa}</TableCell>
                            </TableRow>
                        </React.Fragment>))}
                    </React.Fragment>))}
                </React.Fragment>))}
                {toLoop.length === 1 && toLoop[0].form.additional_schema && toLoop[0].form.additional_schema.length > 0 && (<>
                    <TableRow
                    sx={{ '& > *': {fontWeight: 'bold'}, '&:last-child td, &:last-child th': { border: 0 } }}
                >
                        <TableCell colSpan={4} component="th" scope="row">
                            Additional Information
                        </TableCell>
                        {/*
                        <TableCell align="right"></TableCell>
                        <TableCell align="right"></TableCell>
                        <TableCell align="right"></TableCell>
                        */}
                    </TableRow>
                    {toLoop[0].form.additional_schema.map((question, questionIndex) => (<React.Fragment key={question.id}>
                        <TableRow
                            sx={{ '* > p': {margin: 0}, 'th:first-child': {paddingLeft: '32px'}, '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell colSpan={4} component="th" scope="row">
                                <div style={{/*fontWeight: 'bold',*/ fontStyle: 'italic'}} dangerouslySetInnerHTML={{__html: question.question}}></div>
                                {answerFor(question, `lp_answer_${question.id}`)}
                            </TableCell>
                            {/* <TableCell align="right">{scoreFor('baseline-requirement', requirement).lp}</TableCell> */}
                        </TableRow>
                    </React.Fragment>))}
                </>)}
                </TableBody>
            </Table>
        </TableContainer>
    </>);

    /*
    const formSchema = JSON.parse(record.form_schema);
    const entrySchema = record.hasOwnProperty('entry_schema') ? JSON.parse(record.entry_schema) : null; // we check because we aren't including entry_schema in the list function so it might not immediately be available

    if(entrySchema === null) return null;

    return null;
    // return <ReactFormeoRenderer formData={formSchema} values={entrySchema} />
    */
}

export const FormEntryFrontendButton = (props) => {
    const record = useRecordContext();
    if(!record) {
        return null;
    }
    //frontendFormUrl
    return (
        <Button
            onClick={(e)=>{
                e.stopPropagation();
                window.open(frontendFormUrl(record.form.uuid, record.community_id), '_blank');
            }}
            label={record.status === 'accepted' ? 'View' : 'Review'}
        >
            <RateReviewIcon/>
        </Button>
    );
}

export const FormEntryUpdateStatusButton = (props) => {
    const record = useRecordContext();
    const redirect = useRedirect();
    const notify = useNotify();
    const translate = useTranslate();
    // const dataProvider = useDataProvider();
    const [loading, setLoading] = React.useState(false);

    const [confirmIsOpen, setConfirmIsOpen] = React.useState(false);

    const [status, setStatus] = React.useState(record?.status);
    const [designation, setDesignation] = React.useState(null);

    React.useEffect(() => {
        // only set once
        if(designation === null) {
            setDesignation(record?.community?.designation);
        }

        // set every time
        setStatus(record?.status);
    }, [record]);


    // const [error, setError] = React.useState();

    // const [open, setOpen] = React.useState(false);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
      event.stopPropagation();
      setAnchorEl(event.currentTarget);
    };
    const handleClose = (event) => {
      event.stopPropagation();
      setAnchorEl(null);
    };
    /*
    const [remove, { isLoading }] = useDelete(
        'posts',
        { id: record && record.id }
    );
    */

    // const handleClick = () => setOpen(true);
    // const handleDialogClose = () => setOpen(false);

    const [updateEntryStatus, { data: entryData, isLoading: entryIsLoading, error: entryError }] = useUpdate(
        'form-entries',
        { id: record?.id, data: {}, previousData: record }
    );

    const [updateCommunityDesignation, { data: communityData, isLoading: communityIsLoading, error: communityError }] = useUpdate(
        'communities',
        { id: record?.community_id, data: {}/*, previousData: record*/ }
    );

    const updateStatus = (event, newStatus) => {
        updateEntryStatus(undefined, {
            data: {status: newStatus}
        }).then(response => {
            setLoading(false);
            if(!props.hasOwnProperty('notify') || props.notify) {
                notify('Status updated',/* {type: 'success'}*/);
            }

            try {
                props.onChange(event);
            } catch(e) {
                //
            }
        });
    };

    const updateDesignation = () => {
        //
    };

    const handleConfirm = () => {
        // updateStatus(status);
        // const newDesignation = record.community.designation;
        // updateCommunityDesignation()
        updateCommunityDesignation(undefined, {
            data: {designation: designation}
        }).then(response => {
            setConfirmIsOpen(false);
            setLoading(false);
            if(!props.hasOwnProperty('notify') || props.notify) {
                notify('Designation updated'/*, {type: 'success'}*/);
            }

            /*
            try {
                props.onChange(event);
            } catch(e) {
                //
            }
            */
        });

        // setConfirmIsOpen(false);
    };

    const handleConfirmClose = () => {
        // setLoading(false);
        // updateStatus(null, status);
        setConfirmIsOpen(false);
    };

    const handleStatusClick = (event, newStatus) => {
        handleClose(event);
        setLoading(true);

        updateStatus(event, newStatus);

        // if we're marking as accepted, prompt to choose the designation
        if(newStatus === 'accepted') {
            // setStatus(newStatus);
            setConfirmIsOpen(true);
            return;
        }

        // updateStatus(event, newStatus);

        /*
        authenticatedApi.put(`/form-entries/${record.id}`, {status: newStatus}).then(response => {
            redirect('show', 'form-entries', response.data.id);
            setLoading(false);
            notify('Form updated', {type: 'success'});
        });
        */

        // remove();
        // setOpen(false);
    };

    const {submitted: _submitted, ...restStatues} = formEntryStatuses;
    let availableStatuses = {...restStatues};
    /*
    if(record.status != 'draft') {
        availableStatuses['draft'] = 'In Progress';
    }
    */

    if(!record) {
        return null;
    }

    const ConfirmEditToolbar = (props) => (
        <Toolbar {...props} style={{justifyContent: 'space-between'}}>
            <SaveButton/>
            <Button
                disabled={communityIsLoading}
                onClick={handleConfirmClose}
                startIcon={<AlertError />}
                label="ra.action.cancel"
            >
                {translate('ra.action.cancel', { _: 'ra.action.cancel' })}
            </Button>
        </Toolbar>
    );

    return (<>
        <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={(e)=>{e.stopPropagation(); handleClick(e)}}
        label="Update Status"
        disabled={loading}

      >
        <PublishedWithChangesIcon/>
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {Object.entries(availableStatuses).map(status => {
            if(record.status == status[0]) return null;
            return (<MenuItem key={status[0]} onClick={(e)=>handleStatusClick(e, status[0])}>{status[1]}</MenuItem>);
        })}
      </Menu>
      {/* <EditInDialogButton */}
      <Confirm
        loading={communityIsLoading}
        isOpen={confirmIsOpen}
        title={'Update Designation?'}
        content={<>
            <div style={{marginBottom: '1rem'}}>
                If you would like to update this community's designation, please do so below. The current designation is {designations[record.community?.designation] ?? 'N/A'}.
            </div>

            <FormControl sx={{ minWidth: 200 }} size="small">
                <InputLabel id="demo-select-small-label">Designation</InputLabel>
                <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value={designation}
                    label="Designation"
                    onChange={(e) => {setDesignation(e.target.value)}}
                >
                    {toSelectChoices(designations).map(designation => <MenuItem key={designation.id} value={designation.id}>{designation.name}</MenuItem>)}
                </Select>
            </FormControl>

            {/* <SelectInput label="Designation" resource="communities" source="designation" emptyText={'Choose...'} onChange={() => {}} choices={toSelectChoices(designations)} /> */}
            {/*
            <Edit resource="communities" id={record.id} record={record} hasShow={false}>
            <SimpleForm toolbar={<ConfirmEditToolbar/>}>
            <SelectInput source="designation" emptyText={'Choose...'} choices={toSelectChoices(designations)} />
            </SimpleForm>
            </Edit>
            */}
        </>}
        onConfirm={handleConfirm}
        onClose={handleConfirmClose}
        />
    </>);
};


const FormEntryShowActions = () => {
    return (
        <TopToolbar>
            <FormEntryUpdateStatusButton/>
            <FormEntryFrontendButton/>
            {/*
            <Button color="primary" onClick={handleClick}><>Duplicate</></Button>
            <Confirm
                isOpen={open}
                loading={loading}
                title={`Duplicate form?`}
                content="Are you sure you want to duplicate this form?"
                onConfirm={handleConfirm}
                onClose={handleDialogClose}
            />

            <EditButton />
            */}
        </TopToolbar>
    );
};



const FormEntryShow = props => (
    <Show {...props} actions={<FormEntryShowActions/>}>
        <TabbedShowLayout>
            <Tab label="Summary">
                <SimpleShowLayout>
                    <TextField source="form.name" label="Form" />

                    <FormEntryCommunityField label="Community" source="community" />

                    <FunctionField label="Status" source="status" render={record => getStatuses(record.status)} />

                    {/*
                    <WrapperField label="Person">
                        <TextField source="user.name" /> (#<TextField source="user.driver_id" />)
                    </WrapperField>
                    */}
                    {/* <DateField source="created_at" label="Submitted Date" /> */}
                    {/* <ConditionalScoringField label="Score" /> */}
                    {/* <FormEntryField source="form_schema" label="Form Info" /> */}

                </SimpleShowLayout>
            </Tab>
            <Tab label="View Entry">
                <SimpleShowLayout>
                    <FormEntryField/>
                </SimpleShowLayout>
            </Tab>
            <Tab label="Files" count={<TabCount source="media" />}>
                <ArrayField source="media">
                    <Datagrid bulkActionButtons={false}>
                        <FunctionField source="file_name" render={record => <a href={record.original_url} target="_blank">{record.file_name}</a>} />
                        <FunctionField source="size" render={record => humanFileSize(record.size)} />


                        {/* <TextField source="file_name" /> */}
                    </Datagrid>
                </ArrayField>
            </Tab>
        </TabbedShowLayout>

    </Show>
)

const ShkeFormEditor = () => {
  const input = useController({name: 'schema'});

  return null;

  /*
  return (
    <>

    <ReactFormeoEditor
      formData={input.field.value}
      onChange={(data) => {
        input.field.onChange(data);
      }}
    />
    {/* <ReactFormeoRenderer formData={input.field.value} /> *\/}
    </>
  );
  */
}

export const MyToolbar = () => (
  <Toolbar>
      <SaveButton label="Save" onClick={() => {
        const fields = document.querySelectorAll('.formeo-editor [required]');
          for(const field of fields) {
              field.removeAttribute('required');
          }
      }} />
  </Toolbar>
);

const FormEntryEdit = props => (
    <Edit {...props} redirect="show" mutationMode="pessimistic">
        <SimpleForm toolbar={<MyToolbar />}>
            <TextInput source="name" />
            {/* <SelectInput source="section" required choices={sectionChoices} /> */}
            <TextInput source="category" />
            <TextInput source="email_notifications" helperText={"Comma-separate the email addresses who should be notified when this form is filled out"} />
            <ShkeFormEditor source="schema" />
        </SimpleForm>
    </Edit>
);

/*
const FormBuilderInput = (props) => {
    const input = useController({name: 'schema'});

    return (
        <QuizzBuilder
            // initialValue={initialValue}
            {...props}
            // {...input.field.onChange} // this works because the onChange event is the same
            onChange={(QuizzData) => {
                input.field.onChange(QuizzData);
            }}
        />
    );
};
*/

const FormEntryCreate = props => {
  return (
    <Create {...props} redirect="show">
        <SimpleForm toolbar={<MyToolbar />}>
            <TextInput source="name" />
            {/* <SelectInput source="section" required choices={sectionChoices} /> */}
            <TextInput source="category" />
            <TextInput source="email_notifications" helperText={"Comma-separate the email addresses who should be notified when this form is filled out"} />
            <ShkeFormEditor/>
        </SimpleForm>
    </Create>
)
};

export {FormEntryList, FormEntryShow, FormEntryEdit, FormEntryCreate};
